import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomColumnFilterService {

  constructor() {}

  handleColumnFilterClass(tableFilters,appliedColumnFilterFields:Record<string,boolean>){
      for(const filter in tableFilters){
        const filterValue = tableFilters[filter]?.[0]?.value;
        if(Array.isArray(filterValue)){
          appliedColumnFilterFields[filter] = !!filterValue?.length
        }
        else if(filterValue && typeof filterValue==='object'){
          appliedColumnFilterFields[filter] = !!Object.keys(filterValue)?.length
        }
        else{
          appliedColumnFilterFields[filter] = !!filterValue
        }
      }
      return appliedColumnFilterFields
  }
}
